import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Checkbox } from '../questions/checkbox/Checkbox';
import { CheckboxRadio } from '../questions/checkboxRadio/CheckboxRadio';
import { OneToTenSlider } from '../questions/painSlider/OneToTenSlider';
import { AssessmentPageItem } from '../types/AssessmentPageItem';

export function Behaviour1({
  active,
  assessmentValues,
  questionid,
  questionHeading,
  questionText,
  onOpenModal,
  onSetValue,
}: AssessmentPageItem) {
  const { t } = useTranslation();
  const [goalOptions, setGoalOptions] = useState([
    { id: 'sleep', title: t('B001') },
    { id: 'activity', title: t('B002') },
    { id: 'stress', title: t('B003') },
    { id: 'mh', title: t('B004') },
    { id: 'nutrition', title: t('B005') },
    { id: 'hydration', title: t('B006') },
    { id: 'productivity', title: t('B008') },
    { id: 'energy', title: t('B009') },
  ]);

  const motivatedTextValues = [t('B011'), t('B012')];

  const confidenceTextValues = [t('B011'), t('B013')];

  const stoppingOptions = [
    { id: 'nothing', title: t('B014') },
    { id: 'work', title: t('B015') },
    { id: 'family', title: t('B016') },
    { id: 'time', title: t('B017') },
    { id: 'will_power', title: t('B018') },
    { id: 'finances', title: t('B019') },
    { id: 'mental', title: t('B020') },
    { id: 'physical_health', title: t('B021') },
    { id: 'low_confidence', title: t('B022') },
    { id: 'lack_knowledge', title: t('B023') },
    { id: 'lack_support', title: t('B024') },
  ];

  useEffect(() => {
    const { smoker, drink_alcohol } = assessmentValues || {};

    const addOption = (id, title) => {
      setGoalOptions((prev) => {
        if (!prev.some((item) => item.id === id)) {
          return [...prev, { id, title }];
        }
        return prev;
      });
    };

    if (smoker === 'yes') {
      addOption('smoking', 'Stop smoking');
    }

    if (drink_alcohol !== 'no') {
      addOption('alcohol', 'Drink less alcohol');
    }
  }, [assessmentValues]);

  return (
    <div className={`question_container ${active}`} id={questionid}>
      <h1>{questionHeading}</h1>
      <p>{questionText}</p>

      <CheckboxRadio
        questionid="goal_selected"
        width="_wide"
        questionTitle={t('assessment.question.goal_selected')}
        options={goalOptions}
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
      />
      <OneToTenSlider
        questionid="how_motivated"
        questionTitle={t('assessment.question.how_motivated')}
        width=""
        textValues={motivatedTextValues}
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
      />
      <OneToTenSlider
        questionid="how_confident"
        questionTitle={t('assessment.question.how_confident')}
        width=""
        textValues={confidenceTextValues}
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
      />
      <Checkbox
        questionid="stopping_from_improving"
        width="_wide"
        questionTitle={t('assessment.question.stopping_from_improving')}
        questionTitleSuffix={t('B031')}
        options={stoppingOptions}
        itemLimit="3"
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
        modalText={t('B033')}
        onOpenModal={onOpenModal}
      />
    </div>
  );
}
